export const WINWINMAINPACKAGES = [
    {
        "Name": "Single Ticket for $10",
        "PackageName": "Single Ticket",
        "Cost": 10
    },
    {
        "Name": "Set of 5 Tickets for $20",
        "PackageName": "Set of 5 Tickets",
        "Cost": 20
    },
    {
        "Name": "Set of 10 Tickets for $30",
        "PackageName": "Set of 10 Tickets",
        "Cost": 30
    },
    {
        "Name": "Set of 20 Tickets for $35",
        "PackageName": "Set of 20 Tickets",
        "Cost": 35
    },
    {
        "Name": "Set of 20 Tickets for $40",
        "PackageName": "Set of 20 Tickets",
        "Cost": 40
    },
]

export const WINWIN5050PACKAGES = [
    {
        "Name": "Single Ticket for $5",
        "PackageName": "Single Ticket",
        "Cost": 5
    },
    {
        "Name": "Set of 5 Tickets for $10",
        "PackageName": "Set of 5 Tickets",
        "Cost": 10
    },
    {
        "Name": "Set of 5 Tickets for $15",
        "PackageName": "Set of 5 Tickets",
        "Cost": 15
    },
    {
        "Name": "Set of 10 Tickets for $17.5",
        "PackageName": "Set of 10 Tickets",
        "Cost": 17.5
    },
    {
        "Name": "Set of 10 Tickets for $25",
        "PackageName": "Set of 10 Tickets",
        "Cost": 25
    },
    {
        "Name": "Set of 20 Tickets for $30",
        "PackageName": "Set of 20 Tickets",
        "Cost": 30
    },
    {
        "Name": "Set of 20 Tickets for $35",
        "PackageName": "Set of 20 Tickets",
        "Cost": 35
    }
]

export const DEDUCTIONSCHEDULE = [
    new Date("January 7, 2026"),
    new Date("January 21, 2026"),
    new Date("February 4, 2026"),
    new Date("February 18, 2026"),
    new Date("March 4, 2026"),
    new Date("March 18, 2026"),
    new Date("April 1, 2026"),
    new Date("April 15, 2026"),
    new Date("April 29, 2026"),
    new Date("May 13, 2026"),
    new Date("May 27, 2026"),
    new Date("June 10, 2026"),
    new Date("June 24, 2026"),
    new Date("July 8, 2026"),
    new Date("July 22, 2026"),
    new Date("August 5, 2026"),
    new Date("August 19, 2026"),
    new Date("September 2, 2026"),
    new Date("September 16, 2026"),
    new Date("September 30, 2026"),
    new Date("October 14, 2026"),
    new Date("October 28, 2026"),
    new Date("November 11, 2026"),
    new Date("November 25, 2026"),
    new Date("December 9, 2026"),
    new Date("December 23, 2026"),
]

export const DRAWDATESANDDEADLINES = [
    {
        "DrawDate": "February 12, 2026",
        "Deadline": "January 8, 2026"
    },
    {
        "DrawDate": "March 12, 2026",
        "Deadline": "February 5, 2026"
    },
    {
        "DrawDate": "April 9, 2026",
        "Deadline": "March 5, 2026"
    },
    {
        "DrawDate": "May 14, 2026",
        "Deadline": "April 16, 2026"
    },
    {
        "DrawDate": "June 11, 2026",
        "Deadline": "May 14, 2026"
    },
    {
        "DrawDate": "July 9, 2026",
        "Deadline": "June 11, 2026"
    },
    {
        "DrawDate": "August 13, 2026",
        "Deadline": "July 9, 2026"
    },
    {
        "DrawDate": "September 10, 2026",
         "Deadline": "August 6, 2026"
    },
    {
        "DrawDate": "October 8, 2026",
        "Deadline": "September 17, 2026"
    },
    {
        "DrawDate": "November 12, 2026",
        "Deadline": "October 15, 2026"
    },
    {
        "DrawDate": "December 10, 2026",
        "Deadline": "November 12, 2026"
    },
    {
        "DrawDate": "January 14, 2027",
        "Deadline": "December 10, 2026"
    }
]

// export function nextDrawDate(today) {
//     var futureDraws = DRAWDATESANDDEADLINES.filter(x=>new Date(x.Deadline) >= today);
//     if (futureDraws.length > 0) 

//     return futureDraws[0].DrawDate
// }

// export function nextDrawDateWhenEnrolled(today) {
//     var futureDraws = DRAWDATESANDDEADLINES.filter(x=>new Date(x.DrawDate) >= today);
//     if (futureDraws.length > 0) 

//     return futureDraws[0].DrawDate
// }

// export function nextDeadlineDate(today) {
//     var futureDraws = DRAWDATESANDDEADLINES.filter(x=>new Date(x.Deadline) >= today);
//     if (futureDraws.length > 0) 

//     return futureDraws[0].Deadline
// }